<template>
  <div class="container-fluid p-0" style="background-color:#E6FDFF">
     
  <div class="content" style="background-color:#E6FDFF">
    <header id="page-topbar" style="background-color:rgba(100, 100, 100, 0.4)">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box me-5">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm"><img src="@/assets/images/logo2.jpg" height="30px" style="border-radius: 1%;"/></span>
            <span class="logo-lg"><img src="@/assets/images/logo2.jpg" height="50px" style="border-radius: 1%;"/></span>
          </router-link>
        </div>
        <div class="d-none d-xl-inline-block">

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content><b-button class="btn-sm" variant="primary"> Quick Links <i class="mdi mdi-chevron-down"></i></b-button>
          </template>
            <a target="_blank" href="https://fdc.ug/leadership/" class="dropdown-item text-primary"><i class="fas fa-user-tie font-size-16 align-middle me-1 text-primary"></i> Leadership</a>
            <a target="_blank" href="https://fdc.ug/parliament/" class="dropdown-item text-primary"><i class="fas fa-hospital font-size-16 align-middle me-1 text-primary"></i> Parliament</a>
            <a target="_blank" href="https://fdc.ug/womens-league/" class="dropdown-item text-primary"><i class="bx bx-female font-size-16 align-middle me-1 text-primary"></i> Women's League</a>
            <a target="_blank" href="https://fdc.ug/youth-league/" class="dropdown-item text-primary"><i class="fas fa-walking font-size-16 align-middle me-1 text-primary"></i> Youth League</a>
          </b-dropdown>
      </div>
      </div>

      <div class="d-flex">
        <!-- <button id="toggle" type="button" class="btn btn-sm me-2 font-size-16 d-lg-none header-item" @click="toggleMenu"><i class="fa fa-fw fa-bars text-success"></i></button> -->
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>
          </template>
          <Translator :countries="arrayOfCountries" @on-country-click="customEvent" />
        </b-dropdown>
        <span v-if="memberData==null">
          <a href="/login" class="header-item"><button type="button" class="btn pe-2"><i class="mdi mdi-account-circle text-white mdi-36px"></i></button><span class="h6 d-none d-xl-inline-block text-white">Log in / Become a Member</span></a>
        </span>
        <span v-else>
          <b-dropdown right variant="black" toggle-class="header-item">
            <template v-slot:button-content>
              <img class="rounded-circle header-profile-user" src="@/assets/images/user.png" />
              <span class="d-none d-xl-inline-block h6 text-white ms-1">{{ memberData.first_name.charAt(0) }} {{ memberData.last_name.charAt(0) }}</span>
              <i class="mdi mdi-chevron-down text-white d-none d-xl-inline-block"></i>
            </template>
             <router-link to="/home" class="fw-medium dropdown-item text-success"><i class="mdi mdi-account me-1"></i> My Account</router-link> 
            <a href="/logout" class="dropdown-item text-success"><i class="bx bx-power-off font-size-16 align-middle me-1 text-success"></i> logout</a>
          </b-dropdown>
        </span>
      </div>
    </div>
    </header>
  </div>

  <div class="py-5 border-3 shadow-lg">
    <div class="container border-3 shadow-lg mt-5 p-5" style="background-color: white; border-radius: 20px;">
        
        <h3 style="color: black;" ><span>Packages</span> </h3>
        <div class="row">
          <div v-for="posts in packages" :key="posts.id" class="col-md-4 col-12 my-1">
            <div @click="getPaymentLink(posts.id)" style="cursor: pointer; border-radius: 20px;">
              <div class="row shadow-lg py-2" style="border-radius: 2px 20px;">
                <div class="col-3">
                  <img src="@/assets/images/logo.jpeg" height="100px" style="border-radius: 1%;"/>
                </div>
                <div class="col-9 my-auto">
                  <b class="h5" style="color: black;">{{posts.package_name}}</b><br>
                  <span>{{ formatNumber(posts.amount)}}</span><small class="text-muted"> ugx per Year</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Translator } from 'vue-google-translate';
import appConfig from "@/app.config";
import { packageMethods, packageComputed } from "@/state/helpers";

export default {
  page: {
    title: "Packages | FDC Uganda",
    meta: [{name: "description",content: appConfig.description}],
  },
  
  components: { Translator, },
  data() {
    return {      
      memberData: JSON.parse(localStorage.getItem("member")),
      phone: localStorage.getItem("phone"),
      arrayOfCountries: [
        {  code: 'en|en',  title: 'English',  },
        {  code: 'en|fr',  title: 'French',  },
        {  code: 'en|ar',  title: 'Arabic',  },
        {  code: 'en|es',  title: 'Spanish',  },
        {  code: 'en|de',  title: 'German',  },      
        {  code: 'en|sw',  flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ke.svg',  title: 'Swahili',},
        {  code: 'en|lg',  flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ug.svg',  title: 'Luganda',},
        {  code: 'en|rw',  flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/rw.svg',  title: 'Kinyarwanda',},

      ],
     
      news: [],
      loading: false,
      options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},

    };
  },
  created() {
    this.fetchPackages();
    // Parse member data from localStorage
    this.memberData = JSON.parse(localStorage.getItem("member"));

    // If member data doesn't exist, redirect to index route
    if (!this.memberData) {
      this.$router.push({ name: 'index' }); // Adjust 'index' to your route name
    }
  },
  methods: {
    ...packageMethods,
    formatNumber(num) {
      const [integerPart, decimalPart] = num.toString().split('.');
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    },
    customEvent() {
      this.$emit('on-country-click');
    },
    
    async getPaymentLink(packageId) {
      let url = "/packages/"+this.memberData.id+"/"+packageId;
      await axios.get(url).then((response) => {
      if (response.status == 200) {
        let link = response.data.data;
        if (link) {
          window.open(link, "_blank");
        } else {
          this.error = "No payment link available for this package.";
          alert(this.error);
        }
      }
    })
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
  computed: {
    ...packageComputed,
    limitedNews() {return this.news.slice(0, 6);},
  }
}; 
</script>

<style scoped>
.card img {
  width: 100%;
  height: auto;
  transition: transform 0.3s ease-in-out;
}
.card:hover img {
  transform: scale(1.1);
}
.video-background-container {
  position: relative;
  width: 100%;
  height: 90vh; /* Full viewport height */
  overflow: hidden;
}
.video-background-container video {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -1; /* Behind other content */
  transform: translate(-50%, -50%); /* Center the video */
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.50); /* Black with 50% opacity */
  z-index: 0; /* On top of the video, behind the content */
}
.content { z-index: 1; }
.typing-effect {
    white-space: nowrap;
    overflow: hidden;
    border-right: 2px solid; /* Creates a cursor-like effect */
    /* width: 0; */
    animation: delete 10s steps(110, end), rewrite 8s steps(110, end) 10s forwards;
}

@keyframes delete { 0% {  width: 55ch; } 100% {   width: 0ch;  } }
@keyframes rewrite {  0% {  width: 0ch; }  100% {   width: 55ch;}  }


.map-container {
  height: 500px;
  width: 100%;
}
</style>